import { TEMPLATES_ROUTES } from '../../constants/_routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const templates_index_request = () => {
  return {
    type: templatesTypes.index.request
  }
}

const templates_index_success = (response) => {
  return {
    type: templatesTypes.index.success,
    payload: response.data
  }
}

const templates_index_failure = (messages) => {
  return {
    type: templatesTypes.index.failure,
    payload: messages
  }
}

const templates_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(templates_index_request())

    // Request
    axios.get(
      TEMPLATES_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( templates_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching templates."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( templates_index_failure(errors))
    })
  }

}

const templates_select_success = (response) => {
  return {
    type: templatesTypes.index.select,
    payload: response.data
  }
}


const templates_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(templates_index_request())

    // Request
    axios.get(
      TEMPLATES_ROUTES.select
    ).then( response => {
      // success
      dispatch( templates_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching templates."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( templates_index_failure(errors))
    })
  }
}

export {
  templates_index,
  templates_select
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/getindex.js